import React, { useMemo } from 'react';
import { CheckCircle2, RotateCcw, Archive, FileText } from 'lucide-react';
import { useProperties } from '../hooks/useProperties';
import { PropertyCategoryView } from '../components/properties/PropertyCategoryView';
import { Button } from '../components/ui/Button';
import { Counter } from '../components/ui/Counter';
import { useNavigate } from 'react-router-dom';

export const SoldList: React.FC = () => {
  const { properties, isLoading, updateProperty } = useProperties();
  const navigate = useNavigate();

  const soldProperties = useMemo(
    () => properties.filter((p) => p.status === 'sold'),
    [properties]
  );

  // Génère un rapport des ventes (à implémenter)
  const handleGenerateReport = () => {
    console.log('Génération du rapport des ventes...');
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-4 py-8">
        <div className="mb-8 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-3">
              <CheckCircle2 className="h-8 w-8 text-green-500" />
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                Biens vendus
              </h1>
            </div>
            <Counter 
              count={soldProperties.length} 
              label={soldProperties.length > 1 ? "biens vendus" : "bien vendu"}
              variant="success"
            />
          </div>
          <Button
            variant="secondary"
            onClick={handleGenerateReport}
            className="flex items-center gap-2"
          >
            <FileText className="h-5 w-5" />
            Rapport des ventes
          </Button>
        </div>
        
        <PropertyCategoryView
          title=""
          properties={soldProperties}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};
